import React from 'react';
import Input from 'epic-diesel-form/src/components/form/Input';
import PropTypes from 'prop-types';
import getInfluencersFlowSchema from '../../data/InfluencersFlowSchema';
import {getMessage} from '../common/Message';

class TaxIdInputComponent extends React.Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
        taxType: PropTypes.string,
        value: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };

    formatValue = value => {
        if (this.props.taxType === 'SSN' && value) {
            const extValue = value.replace(/-/g, '');
            const first = extValue.substr(0, 3);
            let second = extValue.substr(3, 2);
            if (second) {
                second = `-${second}`;
            }
            let third = extValue.substr(5, 4);
            if (third) {
                third = `-${third}`;
            }
            return `${first}${second}${third}`;
        }
        return value;
    };

    render() {
        const {taxType, value, disabled, required, messages, onChange} = this.props;
        const taxInfoSchema = getInfluencersFlowSchema(getMessage, messages).taxInfo;

        if (!taxType) {
            return null;
        }
        return (
            <Input
                name={taxInfoSchema[taxType].identifier}
                value={value}
                formatValue={this.formatValue}
                text={taxInfoSchema[taxType].display.text}
                ref={c => {
                    this.inputRef = c;
                }}
                placeholder={taxInfoSchema[taxType].display.placeholder}
                validations={disabled ? {} : taxInfoSchema[taxType].validations}
                validationErrors={taxInfoSchema[taxType].validationMessages}
                onChange={onChange}
                disabled={disabled}
                required={required}
            />
        );
    }
}

export default TaxIdInputComponent;
